declare namespace $ {

	type $mol_view_tree2_to_js_test_ex_array_slot_foo_foot__1 = $mol_type_enforce<
		true
		,
		string|number|boolean
	>
	type $mol_view_tree2_to_js_test_ex_array_slot_foo_foot__2 = $mol_type_enforce<
		`foot1`
		,
		string|number|boolean
	>
	type $mol_view_tree2_to_js_test_ex_array_slot_foo_foot__3 = $mol_type_enforce<
		ReturnType< $mol_view_tree2_to_js_test_ex_array_slot_foo['insert'] >[number]
		,
		string|number|boolean
	>
	export class $mol_view_tree2_to_js_test_ex_array_slot_foo extends $mol_object {
		ins1( ): string
		sub_ins1( ): number
		sub_ins( ): readonly(number)[]
		ins2( ): string
		insert( ): readonly(any)[]
		foot2( ): string
		foot( ): readonly(string|number|boolean)[]
	}
	
}

//# sourceMappingURL=array_slot.view.tree.d.ts.map